// src/components/charts/apex-charts/PerformanceChart.js
import React from "react";
import Chart from "react-apexcharts";

const PerformanceChart = ({ labels, series, title }) => {
  const options = {
    chart: {
      height: 380,
      type: "line",
      zoom: { enabled: false },
      toolbar: { show: false },
    },
    dataLabels: { enabled: false },
    stroke: {
      width: series.map((s) => (s.type === "bar" ? 2 : 3)),
      curve: "smooth",
      lineCap: "round",
    },
    fill: {
      type: "solid",
      opacity: series.map((s) => (s.type === "bar" ? 1 : 0.5)),
    },
    plotOptions: {
      bar: {
        columnWidth: "30%",
        // borderRadius: 4,
        colors: {
          fill: series.map((s) => (s.type === "bar" ? "#007bff" : s.color)),
          stroke: series.map((s) => (s.type === "bar" ? "#007bff" : s.color)),
          strokeWidth: 2,
        },
      },
    },
    legend: {
      position: "top", 
      horizontalAlign: "left", 
      offsetY: -10, 
      fontSize: "12px",
      itemMargin: { horizontal: 10, vertical: 5 },
    },
    xaxis: {
      categories: labels,
      axisBorder: { show: true },
      axisTicks: { show: true },
    },
    yaxis: {
      min: 0,
    },
    grid: {
      borderColor: "#f1f3fa",
      row: {
        colors: ["transparent", "transparent"],
        opacity: 0.2,
      },
    },
    responsive: [
      {
        breakpoint: 768,
        options: {
          chart: { height: 300 },
          legend: { fontSize: "10px" },
        },
      },
    ],
  };

  return (
    <>
      <h4 className="header-title mb-3">{title}</h4>
      <Chart
        options={options}
        series={series}
        type="line"
        className="apex-charts"
        height={380}
      />
    </>
  );
};

export default PerformanceChart;
